import { FC, useContext, useEffect } from "react";
import { CaixaContext } from "./CaixaContext_";
import { formatMoney } from "../../modules/caixa-financeiro/utils/caixa.utils";
import "./CaixaFooterBar.css";

const BOXES: {
  key: "valor_troco" | "valor_recebido" | "valor_em_aberto" | "total_caixa";
  label: string;
  tone: string;
}[] = [
  { key: "valor_troco", label: "TROCO", tone: "troco" },
  { key: "valor_recebido", label: "RECEBIDO", tone: "recebido" },
  { key: "valor_em_aberto", label: "EM ABERTO", tone: "em-aberto" },
  { key: "total_caixa", label: "TOTAL", tone: "total" },
];

/** Rodapé com totais do caixa (Troco / Recebido / Em aberto / Total) */
export const CaixaFooterBar: FC = () => {
  const { caixaAberto, valores, verificaCaixaAberto } = useContext(CaixaContext);

  useEffect(() => {
    verificaCaixaAberto();
    const refresh = () => verificaCaixaAberto();
    window.addEventListener("caixa:session-changed", refresh);
    window.addEventListener("cardapio:pedido-changed", refresh);
    return () => {
      window.removeEventListener("caixa:session-changed", refresh);
      window.removeEventListener("cardapio:pedido-changed", refresh);
    };
  }, [verificaCaixaAberto]);

  if (!caixaAberto) return null;

  return (
    <div className="caixa-footer-bar w-100">
      <div className="row g-3 g-lg-4 w-100 m-0">
        {BOXES.map((box) => (
          <div key={box.key} className="col-6 col-md-3">
            <div className={`caixa-footer-box caixa-footer-box--${box.tone}`}>
              <div className="caixa-footer-box__accent" aria-hidden />
              <div className="caixa-footer-box__content">
                <span className="caixa-footer-box__label">{box.label}</span>
                <span className="caixa-footer-box__value">
                  {formatMoney(valores[box.key])}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
